"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = sanitize;

var _dompurify = _interopRequireDefault(require("dompurify"));

// copied from mobile-frontend
function sanitize(string) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!_dompurify["default"].isSupported) {
    // eslint-disable-next-line no-console
    console.error('DOMPurify is disabled, sanitizing all html tags for security reasons');
    return string.replace(/<[^>]+>/g, '').replace('<', '');
  }

  return _dompurify["default"].sanitize(string, opts || {});
}
//# sourceMappingURL=sanitize.js.map